import React from 'react'
import { Route } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => (

    <Route {...rest} render={(props) => (
        <div className="bus">
            <Component {...props} />
           
        </div>
    )}/>
);

export default PrivateRoute;
